import clsx from "clsx";
import { useTranslation } from "../localization";
import { Spinner } from "../spinner";
import type { FileUploadController } from "./use-file-upload";

/** Props Interface */
interface FileUploadStatusIsFetchingDefaultFilesProps {
	controller: FileUploadController;
}

export function FileUploadStatusIsFetchingDefaultFiles({
	controller,
}: FileUploadStatusIsFetchingDefaultFilesProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!controller.isFetchingDefaultFiles) return null;

	/** Render */
	return (
		<div className={clsx("flex flex-col flex-center gap-2")}>
			<Spinner />
			<p className={clsx("text-primaryGray-500 text-xs")}>
				{t("file_upload.select_files_or_drop_here")}
			</p>
		</div>
	);
}
